import React from 'react'
import loadercss from './loader.css'

export default function Loader() {
  return (
    <div className='spiner-bg'>
        <div className="spinner">
        <div className="dot1"></div>
        <div className="dot2"></div>
        <div className="dot3"></div>
    </div>
    <div className={loadercss}></div>
    </div>

  )
}
